import React from "react";
import { formatDateTime } from "../../../utils/date-formatters";
import { articleRoleLabels } from "../shared/articleRoleLabels";
import type { RecommendationTargetCallArticleLink } from "../../../services/grantsApi";

interface ArticleInTargetCallStatusProps {
  /** Link status for the recommendation's article vs the target call. */
  link: RecommendationTargetCallArticleLink;
}

/**
 * "Czy artykuł jest już w naborze?" — shows, in the recommendation Kontekst
 * panel, whether the article that produced an UPDATE/LINK recommendation is
 * already attached to the call being updated, and when it was added.
 *
 * Spares the moderator from opening the call and comparing article titles/URLs
 * by hand to spot a redundant update.
 */
const ArticleInTargetCallStatus: React.FC<ArticleInTargetCallStatusProps> = ({
  link,
}) => {
  if (!link.linked) {
    return (
      <div className="rounded-md border border-neutral-200 bg-neutral-50 px-3 py-2 text-neutral-700">
        Nie — ten artykuł nie jest jeszcze dodany do tego naboru
      </div>
    );
  }

  return (
    <div className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-amber-800">
      <p className="font-medium">
        Tak — ten artykuł jest już dodany do tego naboru
      </p>
      {link.addedAt && (
        <p className="mt-0.5 text-amber-700">
          Dodano: {formatDateTime(link.addedAt)}
        </p>
      )}
      {link.articleRole && (
        <p className="mt-0.5 text-amber-700">
          Charakter: {articleRoleLabels[link.articleRole] ?? link.articleRole}
        </p>
      )}
      {link.matchedByUrl && (
        <p className="mt-0.5 text-xs text-amber-600">
          (dopasowano po adresie URL — inny rekord artykułu o tym samym URL)
        </p>
      )}
    </div>
  );
};

export default ArticleInTargetCallStatus;
